import { useState } from "react";
import { faqItems, trustPoints, trustStats } from "@/mocks/home";

export default function TrustFaq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="trust" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-page px-4 py-8 md:px-6 md:py-12">
        <div className="rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-8 lg:p-10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
            <div className="lg:col-span-5">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs text-accent-900">
                <i className="ri-shield-star-line text-accent-700" />
                信任与解答
              </span>
              <h2 className="mt-3 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
                为什么可以放心刷
              </h2>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-700 md:text-base">
                爆料最怕真假混着来。我们把来源、更新和纠错都摊开说清楚，让你刷得爽也刷得明白。
              </p>

              <ul className="mt-6 flex flex-col gap-3">
                {trustPoints.map((point) => (
                  <li
                    key={point.title}
                    className="flex gap-3 rounded-lg border border-accent-200/70 bg-background-50 p-3.5"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-900">
                      <i className={`${point.icon} text-lg`} />
                    </span>
                    <div className="min-w-0">
                      <p className="text-sm text-foreground-900">{point.title}</p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                        {point.desc}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="mt-6 grid grid-cols-3 gap-3 rounded-lg border border-accent-200/70 bg-background-50 p-4">
                {trustStats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <p className="font-heading text-xl text-primary-600 md:text-2xl">
                      {stat.value}
                    </p>
                    <p className="mt-1 text-[11px] leading-tight text-foreground-500">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="mb-4 flex items-center justify-between gap-3">
                <h3 className="flex items-center gap-2 font-heading text-xl text-foreground-950">
                  <i className="ri-question-answer-line text-accent-700" />
                  常见问题
                </h3>
                <a
                  href="#trust"
                  className="cursor-pointer whitespace-nowrap text-xs text-accent-900 transition-colors hover:text-primary-600"
                >
                  还有疑问？提交纠错
                </a>
              </div>

              <div className="flex flex-col gap-2.5">
                {faqItems.map((item, index) => {
                  const isOpen = openIndex === index;
                  return (
                    <div
                      key={item.question}
                      className="overflow-hidden rounded-lg border border-accent-200/70 bg-background-50"
                    >
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-3.5 text-left md:px-5"
                      >
                        <span className="flex items-start gap-3">
                          <span className="font-heading text-base text-accent-700">
                            Q{index + 1}
                          </span>
                          <span className="text-sm text-foreground-900 md:text-base">
                            {item.question}
                          </span>
                        </span>
                        <i
                          className={`shrink-0 text-lg text-foreground-400 transition-transform ${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          }`}
                        />
                      </button>
                      {isOpen && (
                        <div className="animate-fade-in border-t border-accent-200/70 px-4 pb-4 pt-3 md:px-5">
                          <p className="text-sm leading-relaxed text-foreground-700">
                            {item.answer}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}